import { observer } from 'mobx-react-lite'
import { type JobDocumentListItemViewModel } from '@/features/documents/JobDocumentListItemViewModel'
import { DocumentListItem } from '@/features/documents/components/DocumentListItem'

export interface DocumentListItemContainerProps {
  vm: JobDocumentListItemViewModel
  selectable?: boolean
  showIcon?: boolean
}

export const DocumentListItemContainer = observer(
  function DocumentListItemContainer({
    vm,
    selectable,
    showIcon,
  }: DocumentListItemContainerProps) {
    return (
      <DocumentListItem
        title={vm.document.title}
        archived={vm.document.archived}
        isPurged={vm.document.isPurged}
        isUploading={vm.uploadPercent !== null}
        isManualAttestationRequired={vm.document.isManualAttestationRequired}
        dateModified={vm.document.dateModified}
        author={vm.author}
        typeName={vm.document.documentType?.name}
        status={vm.status}
        actions={
          vm.document.downloadable
            ? {
                onView: vm.preview,
                onDownload: vm.download,
                onUnlink: vm.canUnlink ? vm.unlink : undefined,
                onDelete: vm.canDelete ? vm.delete : undefined,
              }
            : null
        }
        onPress={vm.view}
        selectable={selectable}
        selected={vm.isSelected}
        onToggleSelected={vm.toggleSelected}
        showIcon={showIcon}
      />
    )
  },
)
